import { useMutation } from "@tanstack/react-query";
import {
  EmployeeIbanService,
  type UpdateEmployeeIbanPayload,
} from "@/shared/services/employeeIban.service";

type EmployeeId = string | number;

export const useVerifyEmployeeIbanMutation = () =>
  useMutation({ mutationFn: (employeeId: EmployeeId) => EmployeeIbanService.verify(employeeId) });

export const useUpdateEmployeeIbanMutation = () =>
  useMutation({
    mutationFn: ({ employeeId, data }: { employeeId: EmployeeId, data: UpdateEmployeeIbanPayload }) =>
      EmployeeIbanService.update(employeeId, data),
  });
